import { useMemo, useState } from 'react'

import { Field, Label, NumberInput, NumberInputProps } from '@makyoapp/makyo-ui'

import { RequirementFieldProps, RequirementLink } from './Requirements'

export type NumberFieldProps = RequirementFieldProps & Omit<NumberInputProps, 'onChange'>

export default function NumberField({ requirement, onValue, value: initialValue }: NumberFieldProps) {
  // TODO: get current user language
  const lang = useMemo(() => 'en', [])

  // ─── States ──────────────────────────────────────────────────────────────────
  const [value, setValue] = useState(initialValue ?? 0)

  return (
    <Field>
      <Label required={requirement._IsMandatory}>{requirement._Label[lang]}</Label>
      <NumberInput
        required={requirement._IsMandatory}
        // TODO: description={requirement._Description[lang]}
        value={value}
        onChange={(v) => setValue(v)}
        onBlur={() => onValue(value.toString())}
      />
      <RequirementLink requirement={requirement} />
    </Field>
  )
}
